import { useState, useEffect, useContext, useRef } from 'react';
import { Modal } from 'bootstrap';
import { CatalogDispatchContext, UxContext } from '../store/CatalogContext';
import { formatCurrency as currency } from '../utils/formatCurrency';
import parse from 'html-react-parser';

export default function BulkRatesModal() {
  const catalogDispatch = useContext(CatalogDispatchContext);
  const ux = useContext(UxContext);

  const bulkModalEl = useRef<HTMLDivElement>(null);

  const [bulkRatesModal, setBulkRatesModal] = useState<Modal | null>(null);
  const [product, setProduct] = useState({
    name: '',
    productBulkTiers: '',
  });

  useEffect(() => {
    if (bulkModalEl.current) {
      const modalInstance = new Modal(bulkModalEl.current);
      setBulkRatesModal(modalInstance);

      bulkModalEl.current.addEventListener('hide.bs.modal', () => {
        // trigger to hide the toast notification
        catalogDispatch({
          type: 'UX',
          payload: {
            showBulkRates: null,
          },
        });
      });
    }
  }, [catalogDispatch]);

  useEffect(() => {
    if (!ux.showBulkRates && bulkRatesModal) {
      bulkRatesModal.hide();
    }
    if (ux.showBulkRates && bulkRatesModal) {
      bulkRatesModal.show();
    }
  }, [ux.showBulkRates, bulkRatesModal]);

  useEffect(() => {
    if (ux.showBulkRates) {
      const bulkRateInfo = () => {
        const bulkTiers =
          ux.showBulkRates && ux.showBulkRates.productBulkTiers
            ? ux.showBulkRates.productBulkTiers.map((tier, index) => {
                return {
                  ...tier,
                  maxQuantity:
                    ux.showBulkRates && ux.showBulkRates.productBulkTiers && ux.showBulkRates.productBulkTiers[index + 1]
                      ? ux.showBulkRates.productBulkTiers[index + 1].minQuantity - 1
                      : null,
                };
              })
            : [];

        let bulkRates = '';

        for (let i = 0; i < bulkTiers.length; i++) {
          const bulkPrice = currency(bulkTiers[i].discountTierUnitPrice);
          const minQuantity = bulkTiers[i].minQuantity;
          const maxQuantity = bulkTiers[i].maxQuantity;

          bulkRates += `Buy <span class="fw-700">${minQuantity}${
            maxQuantity ? `-${maxQuantity}` : ' or more'
          }</span> and get a unit price of <span class="fw-700">${bulkPrice}</span>${maxQuantity ? '<br/>' : ''}`;
        }

        return bulkRates;
      };
      setProduct({
        name: ux.showBulkRates.name,
        productBulkTiers: bulkRateInfo(),
      });
    }
  }, [ux.showBulkRates]);

  return (
    <div className="modal fade text-start lh-16" ref={bulkModalEl} id="bulk-rates-modal" tabIndex={-1} aria-hidden="true">
      <div className="bulk-modal modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body p-3 p-md-4">
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <h3 className="modal-title fw-600 h5 mb-3">Bulk Rates for {product.name}</h3>
            <p className="line-break fw-500 mb-0">{parse(product.productBulkTiers)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
